module.exports = __webpack_public_path__ + "img/bracket-7.a12387b2.svg";